export default {
  SET_LIST_STORE (state, store) {
    state.listStore = store
    state.loading = false
  },
  SET_LOADING_STORE (state, loading) {
    state.loading = loading
  }
}
